<div class="content-container">
    <h1>Målejournal</h1>
    <!-- <router-outlet></router-outlet> -->
    <measurement-log-list [case]="case"></measurement-log-list>
</div>